import { lazy } from 'react';

import { RouteItemType } from 'routes';

const MobileConcierge = lazy(() => import('app/concierge/mobile'));

export const mobileRoutes: Array<RouteItemType> = [
    {
        path: ['/mobile/concierge'],
        name: 'mobile_concierge.name',
        component: MobileConcierge,
        layout: 'blank',
    },
];
